import { render, staticRenderFns } from "./local.vue?vue&type=template&id=9d8174b8&"
import script from "./local.vue?vue&type=script&lang=js&"
export * from "./local.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports